import React from "react";
import { localStorageHelper } from "utils";

import {
  UserIcon,
  HouseIcon,
  CircleIcon,
  LetterIcon,
  InjectionIcon,
  ContactIcon,
  StudentAssociationIcon,
  QRCodeIcon,
  SettingIcon,
  QuestionIcon,
  MentalHealthIcon,
  ResourcesDownloadIcon,
  StressIcon,
  ChatIcon,
  HeartSpeakIcon,
  DashboardIcon,
  ConsultationRequestIcon,
  ImportSSOUsersIcon,
} from "icons";
import { IItems } from "./index";
import { useSelector } from "react-redux";
import { settingDataResponse } from "redux/setting/settingData/settingDataStates";

const filterMenu = (settingData: any) => {
  const accountType = localStorageHelper.getItem("accountType");
  const role = localStorageHelper.getItem("role");

  const menuDefault: any = {
    dashboard: {
      key: "0",
      icon: <DashboardIcon />,
      label: "dashboard-label",
      path: "/dashboard",
    },
    bodyTemperature: {
      key: "1",
      icon: <HeartSpeakIcon />,
      label: "health-observation-label",
      path: "/body-temperature-management",
    },
    messageDelivery: {
      key: "2",
      icon: <LetterIcon />,
      label: "message-delivery-label",
      path: "/message-delivery",
    },
    question: {
      key: "sub4",
      icon: <QuestionIcon fill="#3B3B3B" />,
      label: "questions",
      path: "/questions",
      children: [
        {
          key: "3.1",
          label: "questions-list",
          path: "/questions-list",
        },
        {
          key: "3.2",
          label: "history-list",
          path: "/history-list",
        },
      ],
    },
    mentalCheck: {
      key: "sub5",
      icon: <MentalHealthIcon />,
      label: "mental-health-label",
      path: "/mental-health-observation",
      children: [
        {
          key: "4.1",
          label: "management",
          path: "/mental-health-management",
        },
        {
          key: "4.2",
          label: "implemented-status-25-elementary",
          path: "/elementary-25-questions",
        },
        {
          key: "4.3",
          label: "implemented-status-13-elementary",
          path: "/elementary-13-questions",
        },
        {
          key: "4.4",
          label: "implemented-status-25-junior",
          path: "/junior-25-questions",
        },
        {
          key: "4.5",
          label: "implemented-status-13-junior",
          path: "/junior-13-questions",
        },
        {
          key: "4.6",
          label: "totalling",
          path: "/mental-health-total",
        },
      ],
    },
    qrCode: {
      key: "5",
      icon: <QRCodeIcon />,
      label: "qr-code-label",
      path: "/qr-code",
    },
    resources: {
      key: "6",
      icon: <ResourcesDownloadIcon />,
      label: "resources-download-label",
      path: "/resources-download",
    },
    users: {
      key: "7",
      icon: <UserIcon />,
      label: "user-management-label",
      path: "/user-list",
    },
    class: {
      key: "8",
      icon: <HouseIcon />,
      label:
        accountType === "school"
          ? "class-management-label"
          : "class-management-business-label",
      path: "/class-management",
    },
    activities: {
      key: "9",
      icon: <CircleIcon />,
      label: "activity-management-label",
      path: "/activity-management",
    },
    vaccineInjection: {
      key: "sub1",
      icon: <InjectionIcon />,
      label: "injection-management-label",
      path: "/injection-management",
      children: [
        {
          key: "10.1",
          label: "inoculation-record-label",
          path: "/vaccination-record",
        },
        {
          key: "10.2",
          label: "inoculation-reservation-label",
          path: "/vaccination-appointment",
        },
        {
          key: "10.3",
          label: "list-of-reservations-label",
          path: "/reservation-list",
        },
        {
          key: "3.4",
          label: "venue-setting-label",
          path: "/venue-setting",
        },
      ],
    },
    changeStudentAssociation: {
      key: "sub2",
      icon: <StudentAssociationIcon />,
      label:
        accountType === "school"
          ? "change-student-association-label"
          : "change-student-association-business-label",
      path: "/change-student-association",
      children: [
        {
          key: "11.1",
          label: "change-affiliation-label",
          path: "/change-class",
        },
        {
          key: "11.2",
          label: "confirm-data-label",
          path: "/confirm-data",
        },
        {
          key: "11.3",
          label: "reflect-change-label",
          path: "/reflection-changes",
        },
      ],
    },
    account: {
      key: "sub3",
      icon: <ContactIcon />,
      label: "account-label",
      path: "/account",
      children: [
        {
          key: "12.1",
          label: "account-list-label",
          path: "/account-list",
        },
        {
          key: "12.2",
          label: "register-account-label",
          path: "/account-registration",
        },
      ],
    },
    setting: {
      key: "13",
      icon: <SettingIcon />,
      label: "setting-label",
      path: "/setting",
    },
    message: {
      key: "sub6",
      icon: <LetterIcon />,
      label: "message-delivery-label",
      path: "/message",
      children: [
        {
          key: "14.1",
          label: "message-delivery-label",
          path: "/messages",
        },
        {
          key: "14.2",
          label: "message-list",
          path: "/message-list",
        },
      ],
    },
    stressCheck: {
      key: "sub7",
      icon: <StressIcon />,
      label: "stress-check-label",
      path: "/stress",
      children: [
        {
          key: "15.1",
          label: "stress-management",
          path: "/stress-management",
        },
        {
          key: "15.2",
          label: "stress-59-situation",
          path: "/stress-59-situation",
        },
        {
          key: "15.3",
          label: "stress-25-situation",
          path: "/stress-25-situation",
        },
        {
          key: "15.4",
          label: "stress-total",
          path: "/stress-total",
        },
      ],
    },
    changePassword: {
      key: "16",
      icon: <SettingIcon />,
      label: "change-password-label",
      path: "/change-password",
    },
    contract: {
      key: "17",
      icon: <SettingIcon />,
      label: "contract-information-label",
      path: "/contract",
    },
    consultation: {
      key: "18",
      icon: <ChatIcon />,
      label: "consultation-label",
      path: "/consultation-list",
    },
    usersBusiness: {
      key: "sub8",
      icon: <UserIcon />,
      label: "user-management-label",
      path: "/user-business",
      children: [
        {
          key: "19.1",
          label: "user-management-list",
          path: "/user-list-business",
        },
        // {
        //   key: "19.2",
        //   label: "welfare-registration-overview",
        //   path: "/welfare-registration-overview",
        // },
      ],
    },
    consultationRequest: {
      key: "14",
      icon: <ConsultationRequestIcon />,
      label: "consultation-request-label",
      path: "/consultations-list",
    },
    importSSO: {
      key: "15",
      icon: <ImportSSOUsersIcon fill="#3B3B3B" />,
      label: "import-sso-users-label",
      path: "/import-sso-users",
    },
  };

  const sidebar: any = {
    school: {
      1: [
        "dashboard",
        "bodyTemperature",
        "consultationRequest",
        "messageDelivery",
        "question",
        "mentalCheck",
        "qrCode",
        "resources",
        "users",
        "class",
        "activities",
        "vaccineInjection",
        "changeStudentAssociation",
        "account",
        "importSSO",
        "setting",
      ],
      2: [
        "bodyTemperature",
        "messageDelivery",
        "question",
        "users",
        "qrCode",
        "resources",
        "changeStudentAssociation",
      ],
    },
    business: {
      1: [
        "dashboard",
        "usersBusiness",
        // "bodyTemperature",
        "vaccineInjection",
        "messageDelivery",
        "question",
        // "changeStudentAssociation",
        // "setting",
        "contract",
        "stressCheck",
        "consultation",
      ],
      2: [
        // "bodyTemperature",
        "messageDelivery",
        "question",
        "usersBusiness",
        "qrCode",
        "resources",
        // "changeStudentAssociation",
      ],
    },
  };

  let mainMenu: IItems[] = [];
  let type = "school";

  if (accountType === "company" || accountType === "business") {
    type = "business";
  }

  sidebar[type][role].forEach((item: string) => {
    mainMenu.push(menuDefault[item]);
  });

  if (settingData && Object.keys(settingData?.result).length) {
    const {
      questionnaire_info,
      mental_check_infor,
      vaccine_info,
      temperature_managerment_info,
    } = settingData?.result;

    if (!temperature_managerment_info?.is_consultation_request) {
      mainMenu = mainMenu.filter((item) => {
        return item.label !== "consultation-request-label";
      });
    }
    if (!temperature_managerment_info?.is_create_user_sso) {
      mainMenu = mainMenu.filter((item) => {
        return item.label !== "import-sso-users-label";
      });
    }
    if (!questionnaire_info?.is_questionnaire) {
      mainMenu = mainMenu.filter((item) => {
        return item.label !== "questions";
      });
    }
    if (!mental_check_infor?.is_big_check) {
      mainMenu = mainMenu.filter((item) => {
        return item.label !== "mental-health-label";
      });
    }
    if (!vaccine_info?.is_vaccine) {
      mainMenu = mainMenu.filter((item) => {
        return item.label !== "injection-management-label";
      });
    }
    if (
      settingData?.result &&
      "is_qrscreen" in settingData.result &&
      settingData.result.is_qrscreen === false
    ) {
      mainMenu = mainMenu.filter((item) => {
        return item.label !== "qr-code-label";
      });
    }
  }

  return mainMenu;
};

export const MenuList = () => {
  const settingData = useSelector(settingDataResponse);
  const [list, setList] = React.useState<IItems[]>(filterMenu(settingData));

  return list;
};
